import React, { useState } from "react";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [file, setFile] = useState(null);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState({ type: "", msg: "" });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setResult({ type: "", msg: "" });
    if (!form.name || !form.email || !form.message) {
      setResult({ type: "error", msg: "お名前・メール・内容は必須です。" });
      return;
    }

    setSending(true);
    try {
      // 画像添付に対応 → multipart/form-data
      const fd = new FormData();
      fd.append("name", form.name);
      fd.append("email", form.email);
      fd.append("subject", form.subject);
      fd.append("message", form.message);
      if (file) fd.append("file", file);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/support/contact`, {
        method: "POST",
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "送信に失敗しました。");

      setResult({ type: "ok", msg: "送信しました。返信までしばらくお待ちください。" });
      setForm({ name: "", email: "", subject: "", message: "" });
      setFile(null);
    } catch (err) {
      setResult({ type: "error", msg: err.message || "通信エラーが発生しました。" });
    } finally {
      setSending(false);
    }
  };

  // 共通スタイル（はみ出し対策：boxSizing: 'border-box'）
  const inputBase = {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  const closeTab = () => {
    // 別タブで開かれた想定。開いてくれたウィンドウがあるなら閉じる、無ければ戻る。
    if (window.opener) {
      window.close();
    } else {
      window.history.back();
    }
  };

  return (
    <div style={{ maxWidth: "640px", margin: "0 auto", padding: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <h1 style={{ margin: 0 }}>お問い合わせ</h1>
        <button
          onClick={() => window.close()}
          style={{
            padding: "6px 12px",
            backgroundColor: "#f0f0f0",
            border: "1px solid #ddd",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          title="タブを閉じる"
        >
          閉じる
        </button>
      </div>

      <form
        onSubmit={onSubmit}
        style={{
          background: "#fafafa",
          padding: 16,
          border: "1px solid #eee",
          borderRadius: 8,
          boxSizing: "border-box",
        }}
      >
        <div style={{ marginBottom: 12 }}>
          <label>お名前<span style={{ color: "red" }}> *</span></label>
          <input name="name" value={form.name} onChange={onChange} style={inputBase} />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>メールアドレス<span style={{ color: "red" }}> *</span></label>
          <input type="email" name="email" value={form.email} onChange={onChange} style={inputBase} />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>件名（任意）</label>
          <input name="subject" value={form.subject} onChange={onChange} style={inputBase} />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>お問い合わせ内容<span style={{ color: "red" }}> *</span></label>
          <textarea
            name="message"
            rows={8}
            value={form.message}
            onChange={onChange}
            placeholder={"詳細をご記入ください。\n\n例）\n・◯月◯日のスケジュールが反映されない\n・この操作のやり方を教えてほしい\n・不具合らしき挙動がある など"}
            style={{ ...inputBase, resize: "vertical" }}
          />
        </div>

        {/* 画像添付（任意） */}
        <div style={{ marginBottom: 12 }}>
          <label>画像の添付（任意）</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            style={{ ...inputBase, padding: "6px" }}
          />
          {file && (
            <div style={{ marginTop: 6, fontSize: 12, color: "#555" }}>
              添付：{file.name}（{Math.round((file.size || 0) / 1024)} KB）
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button
            type="submit"
            disabled={sending}
            style={{
              padding: "8px 16px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              opacity: sending ? 0.7 : 1,
            }}
          >
            {sending ? "送信中..." : "送信する"}
          </button>
          {result.msg && (
            <span style={{ color: result.type === "ok" ? "green" : "red", fontSize: 14 }}>{result.msg}</span>
          )}
        </div>
      </form>

      <div style={{ marginTop: 16, fontSize: 12, color: "#666" }}>
        ※ 返信は <b>adsche@tms-ec.co.jp</b> からお送りします。迷惑メールフォルダもご確認ください。
      </div>
    </div>
  );
};

export default ContactPage;